import React from 'react'
import './testimonials.css'
import { Data } from './Data'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from 'swiper'
import { BsBoxArrowUpRight } from 'react-icons/bs'

const Testimonials = () => {
  return (
    <section className="testimonial container section" id="testimonial">
      <h2 className="section__title">Client Feedback</h2>
      <span className="section__subtitle">Testimonial</span>
      <Swiper
        className="testimonial__container"
        loop={true}
        grabCursor={true}
        spaceBetween={24}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          576: {
            slidesPerView: 1,
            spaceBetween: 48,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 48,
          },
        }}
        modules={[Pagination]}
      >
        {Data.map(({ id, image, title, description }) => {
          return (
            <SwiperSlide className="testimonial__card" key={id}>
              <img src={image} alt="client" className="testimonial__img" />
              <h3 className="tetimonial__name">
                <a
                  href="https://www.linkedin.com/in/abhishekhonnapure/details/recommendations/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {title}
                  <BsBoxArrowUpRight className="arrow_icon" />
                </a>
              </h3>
              <p className="testimonial__description">{description}</p>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </section>
  )
}

export default Testimonials
